import styled from 'styled-components';

export const Container = styled.div<{ $isFirst?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(1)};

  margin: ${({ theme, $isFirst }) =>
    `${$isFirst ? theme.spacing(1.5) : theme.spacing(4)} ${theme.spacing(1.5)} ${theme.spacing(1.5)} ${theme.spacing(4)}`};
  padding: ${({ theme }) => `${theme.spacing(2)} 0`};

  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
`;

export const HoverActions = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};

  opacity: 0;
  pointer-events: none;
  transition: opacity 200ms ease-in-out;

  ${Container}:hover & {
    opacity: 1;
    pointer-events: auto;
  }
`;

export const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1.6)};
`;
